import BannerCell from './BannerCell';
import ArticleCell from './ArticleCell';
import ModuleCell from './ModuleCell';
import RecommandCell from './RecommandCell';
import ThreeCell from './ThreeCell';
import ImgTextCell from './ImgTextCell';
import ClassifyCell from './ClassifyCell';
import ClassifyRecommandCell from './ClassifyRecommandCell';
import GoodsCell from './GoodsCell';
import AdPictureCell from './AdPictureCell';
import GoodsFloorCell from './GoodsFloorCell';
import TitleCell from './TitleCell';
import SliderCell from './SliderCell';
import LinkStoreInfoCell from './LinkStoreInfoCell';
import StoreInfoCell from './StoreInfoCell';

export {
  BannerCell,
  ArticleCell,
  ModuleCell,
  RecommandCell,
  ThreeCell,
  ImgTextCell,
  ClassifyCell,
  ClassifyRecommandCell,
  GoodsCell,
  AdPictureCell,
  GoodsFloorCell,
  TitleCell,
  SliderCell,
  LinkStoreInfoCell,
  StoreInfoCell
};



// WEBPACK FOOTER //
// ./src/pubBiz/CommonCell/index.js